import { render } from "./CreateMastertag.vue?vue&type=template&id=451e6dd9&scoped=true"
import script from "./CreateMastertag.vue?vue&type=script&lang=js"
export * from "./CreateMastertag.vue?vue&type=script&lang=js"

import "./CreateMastertag.vue?vue&type=style&index=0&id=451e6dd9&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451e6dd9"]])

export default __exports__